import { ThunkDispatch } from 'redux-thunk';
import { toast } from 'react-toastify';
import { isAPIFailed, isAPISuccess } from '../utils/Util';
import { CLICK_ACTIONS } from '../utils/Constant';
import { removeAssignedGrid } from '../features/onboardingSlice';
import { getCandidateDetails } from '../features/assignGridSlice';

export const handleRemove = (
  removeGridId: any,
  candidateId: any,
  loggedCandidateID: any,
  refreshData: () => void,
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  const data = {
    candidateId: candidateId,
    gridId: Number(removeGridId.trim()),
  };
  console.log('data-1609', data);
  dispatch(removeAssignedGrid(data))
    .then(async (fulfilled: any) => {
      console.log('fulfilled', fulfilled);
      if (isAPIFailed(fulfilled?.payload)) {
        if (fulfilled?.payload?.responseInformation?.responseMessage) {
          toast.error(fulfilled?.payload.responseInformation.responseMessage);
        }
      } else if (isAPISuccess(fulfilled?.payload)) {
        toast.success(fulfilled?.payload.responseInformation.responseMessage);
        await dispatch(getCandidateDetails(candidateId));
        await refreshData();
        setShowLoader(false);
      } else if (fulfilled?.payload?.message) {
        toast.error(fulfilled?.payload?.message);
      }
    })
    .catch((err: any) => {
      console.log(err);
      toast.error('Error occurred while removing');
    });
};

export const onRemove = (
  id: any,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveGridId: (param: string) => void
) => {
  setShowAlertPopUp(true);
  setRemoveGridId(id);
};
export const alertPopupToggle = (
  action: string,
  removeGridId: string,
  dispatch: ThunkDispatch<any, any, any>,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveGridId: (param: any) => void,
  candidateId: any,
  loggedCandidateID: any,
  refreshData: () => void,
  setShowLoader: (param: boolean) => void
) => {
  if (action === CLICK_ACTIONS.APPROVE) {
    handleRemove(
      removeGridId,
      candidateId,
      loggedCandidateID,
      refreshData,
      setShowLoader,
      dispatch
    );
  }
  setShowAlertPopUp(false);
  setRemoveGridId(null);
};
